import { render } from "./TopNavBar.vue?vue&type=template&id=1265b5e7&scoped=true"
import script from "./TopNavBar.vue?vue&type=script&lang=js"
export * from "./TopNavBar.vue?vue&type=script&lang=js"

import "./TopNavBar.vue?vue&type=style&index=0&id=1265b5e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1265b5e7"]])

export default __exports__